$bog_fragile_demo_rename_heir2 $bog_fragile_demo_rename_base2
	heading \Наследник
